import { useState } from 'react';
import PhotoSection from '../../PhotoSection';
import { LAB_PHOTO_TYPES } from '../../../constants/photoTypes';
import { defaultPlateId } from '../quickActions';
import { PlatePicker, stack } from './shared';
import * as S from '../../specimens/styles';

/*
 * A lab photo of one of the isolate's plates: the plate page's own photo
 * section (PhotoSection, which uploads and lists by itself), aimed at the
 * chosen plate. "Done" closes the drawer and re-reads the row's counts.
 */
export default function LabPhotoForm({ item, plates, extra = {}, t, onDone, onCancel }) {
  const [plateId, setPlateId] = useState(extra.plateId || defaultPlateId(item, plates));
  if (!plates.length) return <p style={S.hint}>{t('quick.noPlates')}</p>;
  return (
    <div style={stack} data-testid="quick-lab-photo">
      <PlatePicker plates={plates} value={plateId} onChange={setPlateId} t={t} />
      <PhotoSection key={plateId} fetchUrl={`/plates/${plateId}/photos`} uploadBody={{ plate_id: plateId }}
        taxonName={item.taxon_name} sourceType="lab" photoTypes={LAB_PHOTO_TYPES} />
      <div style={{ display: 'flex', gap: 8 }}>
        <button type="button" style={S.btn()} onClick={() => onDone(t('toast.photosUpdated'))} title={t('tip.quick.photosDone')}
          data-testid="quick-photo-done">{t('quick.done')}</button>
        <button type="button" style={S.ghostBtn} onClick={onCancel} title={t('tip.quick.cancel')}>{t('common:cancel')}</button>
      </div>
    </div>
  );
}
